

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";
import UserApi from "../../services/UserApi";
//import { auth, signInWithEmailAndPassword, signInWithGoogle } from "../../firebase";

import { useDispatch } from "react-redux";





import axios from 'axios'
import { useGlobalFunc } from "../../global/constants";

const Home = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const { setLoading, successToast, errorToast, updateMe } = useGlobalFunc()

    const [step, setStep] = useState(0)

    const banner = []
    const [currBanner, setCurrBanner] = useState(0)
    const countRef = useRef()



    const [faqs, setFAQ] = useState([


    ]);

    const [account, setAccount] = useState("")
    const [pw, setPw] = useState("")

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [forgetInput, setForgetInput] = useState("")
    const [otp, setOTP] = useState("")
    const [infoName, setInfoname] = useState("")
    const [infoPassword, setInfoPassword] = useState("")
    const [infobirth, setInfobirth] = useState("")

    const [isLoginError, setIsLoginError] = useState(false)
    const [isOTPError, setIsOTPError] = useState(false)



    const [FAQType, setFAQType] = useState(0);
    const [isFisrt, doneFisrt] = useState(false)

    function changeFAQType(type) {
        setFAQType(type)
    }

    function changeFAQItem(index) {
        console.log(faqs[FAQType][index])
        faqs[FAQType][index].open = !faqs[FAQType][index].open
        console.log(faqs[FAQType][index])
        setFAQ([...faqs])
    }



    async function loginAction() {
        if (account == "" || pw == "") {
            errorToast("請輸入帳號和密碼")
            return
        }

        setLoading(true)

        try {
            let res = await UserApi.signIn({ accountId: account, accountPw: pw })
            console.log(res)

            localStorage.setItem("userToken", res.data.data.token)
            updateMe()
            navigate('/membercenter')
            //window.location.reload()
        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }

        setLoading(false)

    }





    useEffect(() => {

        const token = query.get('token')
        if (token != null) {
            //localStorage.setItem("userAuth",token)
            setStep(100)


        }


    }, []);


    return <div className="" >

        <div className="flex w-full h-full bg-white md:py-10">
            <div className="m-auto bg-black2 border-solid border-2 border-black4  w-full max-w-[470px] p-7 md:rounded-[20px]">
                {
                    step == 0 ?
                        <div className="relative py-7">
                            <img className="w-[62px] mx-auto  object-contain mb-6"  />

                            <p className="text-[#9FA2B4] text-xl text-center  titleFont1 mb-7">AlphaMars</p>

            

                            <p className="text-lg md:text-xl text-[#111111] font-bold text-left mb-8">歡迎回來</p>

                            <p className="text-black9 font-bold mb-2 text-sm">帳號</p>
                            <div className="flex gap-2 items-center text-black9 mb-6">
                                <input value={account} onChange={e => setAccount(e.target.value)} type="text" className=" text-lg  w-full" />
                            </div>

                            <p className="text-black9 font-bold mb-2 text-sm">密碼</p>
                            <input placeholder="" value={pw} onChange={e => setPw(e.target.value)} type="password" className="mb-10  relative    w-full  text-lg" />


                            <button  onClick={() => loginAction()} className=" font-bold bg-red1  text-white w-full rounded-md py-4 ">登入</button>

  

                       


                        </div>
                        : ""
                }

                {
                    step == 1 ?
                        <div className="relative ">
                            <div className="flex justify-between mb-[100px]">
                                <button className="w-7 h-7"><img className="w-full h-full object-contain" onClick={() => setStep(step - 1)} /></button>
                                <p className="text-lg md:text-xl text-[#111111] font-bold text-center">註冊/登入</p>
                                <div className="w-7 h-7"></div>
                            </div>


                            <div className="px-3 ">
                                <div className="flex items-center  mb-2">
                                    <img className="w-7 h-7 mr-[10px] object-contain " />
                                    <input className="text-lg text-sec4 placeholder-[#B7B7B7]" onChange={(e) => setEmail(e.target.value)} placeholder="Email" type="text" />

                                </div>
                                <div className="w-full h-[2px] bg-[#D9D9D9] mb-[128px]"> </div>


                                <div className="w-[220px] rounded-full bg-black cursor-pointer text-white text-center mx-auto py-[14px] font-medium mb-10">
                                    註冊/登入
                                </div>
                            </div>

                        </div>
                        : ""
                }

                {
                    step == 2 ?
                        <div className="relative ">
                            <div className="flex justify-between mb-[40px]">
                                <button className="w-7 h-7"><img className="w-full h-full object-contain" onClick={() => setStep(step - 1)} /></button>
                                <p className="text-lg md:text-xl text-[#111111] font-bold text-center">登入</p>
                                <div className="w-7 h-7"></div>
                            </div>

                            <p className="text-xl font-medium text-[#111111]">歡迎回來！</p>
                            <p className="text-base text-[#111111] mb-[40px]">{email}</p>


                            <div className="px-3 ">
                                <div className="flex items-center  mb-2">
                                    <img className="w-7 h-7 mr-[10px] object-contain " />
                                    <input className="text-lg text-sec4 placeholder-[#B7B7B7]" onChange={(e) => setPassword(e.target.value)} placeholder="" type="password" />

                                </div>
                                <div className={`w-full h-[2px]  ${isLoginError == true ? "bg-[#EB480D]" : "bg-[#D9D9D9]"} `}> </div>

                                <div className="mt-2 flex justify-between">
                                    {
                                        isLoginError == true ?
                                            <p className="text-[#EB480D] text-sm">您輸入的密碼錯誤</p> :
                                            <p></p>
                                    }
                                    <button className='underline text-sm text-[#111111] font-medium'>忘記密碼？</button>
                                </div>

                                <div className="mt-[68px] w-[220px] rounded-full bg-black cursor-pointer text-white text-center mx-auto py-[14px] font-medium mb-10">
                                    登入
                                </div>
                            </div>

                        </div>
                        : ""
                }

                {
                    step == 30 ?
                        <div className="relative ">
                            <div className="flex justify-between mb-[40px]">
                                <button className="w-7 h-7"><img className="w-full h-full object-contain" onClick={() => setStep(step - 1)} /></button>
                                <p className="text-lg md:text-xl text-[#111111] font-bold text-center">忘記密碼</p>
                                <div className="w-7 h-7"></div>
                            </div>

                            <p className="text-xl font-medium text-[#111111]">輸入您的 Email</p>
                            <p className="text-base text-[#888888] mb-[40px]">會將新密碼寄至您的信箱</p>



                            <div className="px-3 ">
                                <div className="flex items-center  mb-2">
                                    <img className="w-7 h-7 mr-[10px] object-contain " />
                                    <input className="text-lg text-sec4 placeholder-[#B7B7B7]" onChange={(e) => setPassword(e.target.value)} placeholder="" type="text" />

                                </div>
                                <div className={`w-full h-[2px] bg-[#D9D9D9] `}> </div>



                                <div className="mt-[98px] w-[220px] rounded-full bg-black cursor-pointer text-white text-center mx-auto py-[14px] font-medium mb-10">
                                    寄送新密碼
                                </div>
                            </div>

                        </div>
                        : ""
                }
                {
                    step == 3 ?
                        <div className="relative ">
                            <div className="flex justify-between mb-[40px]">
                                <button className="w-7 h-7"><img className="w-full h-full object-contain" onClick={() => setStep(step - 1)} /></button>
                                <p className="text-lg md:text-xl text-[#111111] font-bold text-center">輸入驗證碼</p>
                                <div className="w-7 h-7"></div>
                            </div>

                            <p className="text-xl font-medium text-[#111111]">已將驗證碼傳送到您的信箱</p>
                            <p className="text-base text-[#888888] mb-[40px]">{email}</p>



                            <div className="px-3 ">
                                <div className="flex items-center  mb-2">

                                    <input className="text-lg text-sec4 placeholder-[#B7B7B7]" onChange={(e) => setOTP(e.target.value)} placeholder="驗證碼" type="text" />

                                </div>
                                <div className={`w-full h-[2px]  ${isOTPError == true ? "bg-[#EB480D]" : "bg-[#D9D9D9]"} `}> </div>
                                <p className="mt-2 text-[#EB480D] text-sm">{isOTPError == true ? "驗證碼已過期" : ""}</p>




                                <div className="mt-[98px] w-[220px] rounded-full bg-black cursor-pointer text-white text-center mx-auto py-[14px] font-medium mb-6">
                                    下一步
                                </div>

                                <div className="mt-2 flex justify-center">
                                    <p className="text-[#B7B7B7] text-sm mr-[10px]">重新發送驗證碼</p>
                                    <button className=' text-sm text-[#B7B7B7] font-medium'>1m 40s</button>
                                </div>
                            </div>

                        </div>
                        : ""
                }

                {
                    step == 100 ?
                        <div className="relative py-7">
                            <Link to="/home">
                                <div className="text-black absolute -top-2 right-0 text-base font-medium ">略過
                                </div>
                            </Link>


                            <p className="text-2xl font-bold text-[#111111] text-center mb-[20px]">歡迎加入AlphaMars！</p>
                            <p className="text-lg text-[#888888] mb-[37px] text-center ">您已經成功註冊 AlphaMars</p>



                            <div className="px-3 bg-[#F5F5F5] rounded-[10px] pt-[64px] pb-[45px]">
                                <img className="bg-white mx-auto w-[210px]  object-contain mb-[45px] p-2" />


                            </div>

                        </div>
                        : ""
                }



            </div>





        </div>



    </div>
}

export default Home